import { doFetchRequest } from '@r1-frontend/do-request/doFetchRequest';
import getCityInfo, { ResponseDto } from '@r1-frontend/api-domru/api-content/v1/geography/get-city-info';

import { getCityDomainByAgreement } from './byAgreement';
import { getCityDomainByGeoIpService } from './byGeoIpService';

const DEFAULT_CITY_DOMAIN = 'perm';

interface IGetCityDomainOptions {
    // Можно выключить geo-определение и всегда возвращать город-домен по умолчанию
    enabled: boolean,
}

interface IGetCityDomain {
    cityDomain: string,
    method: 'cityDomainCookie' | 'agreement' | 'ip' | 'default' | 'disabled' | 'providerId',
}

/**
 * @param definedProviderId providerId, сохраненный в куке
 * @param definedCityDomain город-домен, сохраненный в куке
 * @param agreement номер договора, сохраненный в куке
 * @param ip ipv4
 * @param {IGetCityDomainOptions} options
 */
const getCityDomain = async(
    definedProviderId: number | undefined,
    definedCityDomain: string | undefined,
    agreement: string | undefined,
    ip?: string,
    options?: IGetCityDomainOptions,
): Promise<IGetCityDomain> => {
    if (definedProviderId) {
        const cityInfo = await doFetchRequest.apiContent<ResponseDto>(
            getCityInfo({ providerId: definedProviderId, fields: 'domain', onlyActive: false }),
        );
        if (cityInfo.isSuccess) {
            return { cityDomain: cityInfo.payload.domain, method: 'providerId' };
        }
    }

    if (definedCityDomain) {
        return { cityDomain: definedCityDomain, method: 'cityDomainCookie' };
    }

    if (agreement) {
        const domainByAgreement = getCityDomainByAgreement(agreement);
        if (domainByAgreement) {
            return { cityDomain: domainByAgreement, method: 'agreement' };
        }
    }

    if (options?.enabled === false) {
        return { cityDomain: DEFAULT_CITY_DOMAIN, method: 'disabled' };
    }

    // Для песка всегда определяется gp и Воронеж, а не реальный ip-адрес
    if (ip) {
        const domainByGeoIp = await getCityDomainByGeoIpService(ip);
        if (domainByGeoIp) {
            return { cityDomain: domainByGeoIp, method: 'ip' };
        }
    }

    return { cityDomain: DEFAULT_CITY_DOMAIN, method: 'default' };
};

export default getCityDomain;
